import { IAppConfiguration, IInitParams } from "Configuration";
import { IUser } from "contracts";

import { IUserSettingsManager } from "OW.Remoting/Remoting/IUserSettingsManager";
import { IAppAddresses } from "./IAppAddresses";

/**
 * Kontext s informacemi o aplikaci. Některé informace jsou lokální pro každé okno, některé jsou sdílené napříč všemi okny.
 * @includeToDoc
 */
export interface IAppContext {
    /** Unikátní identifikátor aplikace (založený na její url) */
    readonly appId: string;
    /** Nastavení celé klientské části aplikace */
    readonly configuration: IAppConfiguration;
    /** Url adresy klientské části a webové služby */
    readonly addresses: IAppAddresses;
    /** Mapa rozparsovaných url parametrů současné adresy aplikace */
    readonly addressParams: Map<string, string>;
    /** Data přihlášeného uživatele */
    readonly currentUser: IUser;

    /** Pole ID aktivních rolí */
    readonly activeUserRolesIds: string[];
    /** Regulární výraz určující výchozí html stránky aplikace */
    basePages: RegExp | undefined;

    /**
     * Ziniciuje kontext aplikace. Automaticky si načte nastavení aplikace ze standardního umístění, pokud ho nedostane parametrem.
     * @param initParams Umožňuje předat custom nastavení aplikace
     */
    initialize(initParams?: IInitParams): Promise<void>;

    /**
     * Umožňuje nastavit data přihlášeného uživatele.
     * @param user Data přihlášeného uživatele
     */
    setCurrentUser(user: IUser): void;

    /**
     * Umožňuje uložit aktivní role
     * @param ids ID aktivních rolí
     */
    setActiveUserRolesIds(ids: readonly string[]): void;

    /**
     * Umožňuje nastavit aktivní okruhy na server.
     * @param userSettingsManager User manager
     */
    setActiveUserRolesRanges(userSettingsManager: IUserSettingsManager): void;

    /*
      * Vrací promise, který se resolvne až je kontext inicializovaný
    */
    waitForInitialized(): Promise<void>;

}
